import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {map, share} from 'rxjs/operators';
import {DISPATCHER_PREFIX} from '../../../consts/data-service-consts';
import {FilterObj, KeyValueObj, OperatorDetailsObj, TrackerVariableObj, ValidationResponseObj} from 'mx-core';


const FILTERS_URL = DISPATCHER_PREFIX + '/filters';

@Injectable({
    providedIn: 'root'
})
export class BoFiltersService {

    constructor(private httpClient: HttpClient) {
    }

    isFilterValidForTracker(trackerId: number, filter: FilterObj): Observable<Boolean> {
        return this.httpClient.post<Boolean>(FILTERS_URL + '/is-valid-for-trackers/' + trackerId, filter);
    }

    getVariables(trackerId: number): Observable<Array<TrackerVariableObj>> {
        return this.httpClient.get<Array<TrackerVariableObj>>(FILTERS_URL + '/tracker-variables/' + trackerId);
    }

    getRotatingZoneVariables(): Observable<Array<TrackerVariableObj>> {
        return this.httpClient.get<Array<TrackerVariableObj>>(FILTERS_URL + '/rotating-zone-variables')
            .pipe(share());
    }

    getOperators(): Observable<Array<OperatorDetailsObj>> {
        return this.httpClient.get<Array<OperatorDetailsObj>>(FILTERS_URL + '/operators');
    }

    getDynamicOperands(): Observable<Map<string, Array<KeyValueObj>>> {
        return this.httpClient.get<Map<string, Array<KeyValueObj>>>(FILTERS_URL + '/dynamic-operand')
            .pipe(
                map(response => {
                    return new Map<string, Array<KeyValueObj>>(Object.entries(response));
                }))
            ;
    }

    public restoreFilters(ids: Array<number>): Observable<ValidationResponseObj | string | null> {
        return this.httpClient.put<ValidationResponseObj | string | null>(FILTERS_URL + '/restore', ids);
    }

    public getDefaultFilter(): Observable<FilterObj> {
        return this.httpClient.get<FilterObj>(FILTERS_URL + '/default');
    }

    public getRawFilter(filter: any): string {
        const allKeys: Set<string> = new Set();
        JSON.stringify(filter, (key, value) => {
            allKeys.add(key);
            return value;
        });
        const jsonFilter = JSON.parse(JSON.stringify(filter));
        const replacer = Array.from(allKeys).sort();
        return JSON.stringify(this.sortObject(this.flattenObject(jsonFilter)), replacer)
    }

    private sortObject = (obj: any): any => {
        if (!obj.childs) {
            return obj;
        }
        return obj.childs.sort((a, b) => a.ruleInfo.variable.localeCompare(b.ruleInfo.variable));
    }

    flattenObject(obj: any): any {
        const flattenChilds = (childs: any[]): any[] => {
            return childs.reduce((acc, child) => {
                if (child.type === 'group') {
                    acc.push(...flattenChilds(child.childs));
                } else {
                    acc.push(child);
                }
                return acc;
            }, []);
        };

        if (obj.childs) {
            obj.childs = flattenChilds(obj.childs);
        }

        return obj;
    }
}
